import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";

const PrevProfilesCreatedYearToDate = () => {
  const prevProfilesCreatedYTD = useSelector(
    (state) => state.leadsAdded.leads.prevProfilesCreatedYTD
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return <NumberDisplay value={prevProfilesCreatedYTD} disableAnimation={isUserQa} />;
};

export default PrevProfilesCreatedYearToDate;
